<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<v-form v-model="valid" ref="form">
				<CheckSheetForm :check_sheet.sync="check_sheet" />
				<v-row no-gutters justify="center" class="mb-4">
					<v-col cols="12" sm="4">
						<v-btn
							class="mt-4"
							width="100%"
							color="secondary"
							@click="createCheckSheet('draft')"
							:disabled="!valid"
						>
							<v-icon class="mr-1"> mdi-content-save-outline </v-icon>
							下書き保存</v-btn
						>
					</v-col>
					<v-col cols="12" sm="4">
						<v-btn
							width="100%"
							class="ml-2 mt-4"
							color="secondary"
							@click="createCheckSheet('pending')"
							:disabled="!valid"
						>
							<v-icon class="mr-1"> mdi-send </v-icon>
							承認依頼
						</v-btn>
					</v-col>
				</v-row>
			</v-form>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import CheckSheetForm from "./components/CheckSheetForm.vue"

export default {
	components: {
		CommonFlame,
		CheckSheetForm,
	},
	data() {
		return {
			title: "新規チェックシート作成",
			check_sheet: {
				order_individual_info_id: null,
				product_name: null,
				drawing_number: null,
				quantity: null,
				customer_product_number: null,
				instructions_number: null,
				check_sheet_template_id: null,
				name: null,
				issuer_id: null,
				meeting_flag: false,
				meeting_agendas_attributes: [],
			},
			valid: false,
		}
	},
	methods: {
		createCheckSheet(status) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/check_sheets`
			let params = {
				check_sheet: {
					status,
					...this.check_sheet,
				},
			} // TODO
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					this.$router.push({ name: "check_sheet_index" })
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
